const mutations = {
  changeActivedIndex(state, payload) {
    // console.log(state);
    // console.log(payload);
    state.activedIndex = payload;
  }
};

export default mutations;
